export interface ThemePreset {
  name: string;
  description: string;
  category: string;
  variables: Record<string, any>;
}

export const themePresets: ThemePreset[] = [
  // 商务主题
  {
    name: '现代简约',
    description: '简洁现代的设计风格，适合商务场景',
    category: '商务',
    variables: {
      primaryColor: '#1890ff',
      secondaryColor: '#722ed1',
      accentColor: '#13c2c2',
      successColor: '#52c41a',
      warningColor: '#faad14',
      errorColor: '#ff4d4f',
      infoColor: '#1890ff',
      backgroundColor: '#f5f5f5',
      surfaceColor: '#ffffff',
      cardColor: '#ffffff',
      borderColor: '#d9d9d9',
      textColor: '#262626',
      textSecondaryColor: '#8c8c8c',
      textDisabledColor: '#bfbfbf',
      hoverColor: '#f0f0f0',
      activeColor: '#e6f7ff',
      backgroundOpacity: 1,
      cardOpacity: 1,
      borderOpacity: 1,
      borderRadius: '6px',
      cardBorderRadius: '8px',
      buttonBorderRadius: '6px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
      cardShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '1.5',
      spacing: '16px',
      padding: '16px',
      margin: '16px',
      transitionDuration: '0.3s',
      transitionTiming: 'cubic-bezier(0.4, 0, 0.2, 1)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      // 头部和导航条
      headerBackgroundColor: '#ffffff',
      headerTextColor: '#262626',
      headerHeight: '64px',
      headerPadding: '0 24px',
      headerBoxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      headerBorderBottom: '1px solid #f0f0f0',
      headerOpacity: 1,
      navBackgroundColor: '#ffffff',
      navTextColor: '#262626',
      navHoverColor: '#f0f0f0',
      navActiveColor: '#e6f7ff',
      navHeight: '48px',
      navPadding: '0 16px',
      navBorderRadius: '6px',
      navBoxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      navOpacity: 1,
      logoSize: '32px',
      logoColor: '#1890ff',
      logoHoverColor: '#40a9ff',
      menuItemPadding: '8px 16px',
      menuItemBorderRadius: '6px',
      menuItemHoverBackground: '#f0f0f0',
      menuItemActiveBackground: '#e6f7ff',
      menuItemTextColor: '#262626',
      menuItemHoverTextColor: '#1890ff',
      menuItemActiveTextColor: '#1890ff',
      customCSS: ''
    }
  },
  {
    name: '商务精英',
    description: '专业商务风格，深蓝配色彰显权威感',
    category: '商务',
    variables: {
      primaryColor: '#1e3a8a',
      secondaryColor: '#3730a3',
      accentColor: '#3b82f6',
      successColor: '#059669',
      warningColor: '#d97706',
      errorColor: '#dc2626',
      infoColor: '#0284c7',
      backgroundColor: '#f8fafc',
      surfaceColor: '#ffffff',
      cardColor: '#ffffff',
      borderColor: '#e2e8f0',
      textColor: '#1e293b',
      textSecondaryColor: '#64748b',
      textDisabledColor: '#94a3b8',
      hoverColor: '#f1f5f9',
      activeColor: '#dbeafe',
      backgroundOpacity: 1,
      cardOpacity: 1,
      borderOpacity: 1,
      borderRadius: '8px',
      cardBorderRadius: '12px',
      buttonBorderRadius: '8px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)',
      cardShadow: '0 4px 6px rgba(0, 0, 0, 0.05), 0 10px 15px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '1.6',
      spacing: '20px',
      padding: '20px',
      margin: '20px',
      transitionDuration: '0.2s',
      transitionTiming: 'cubic-bezier(0.4, 0, 0.2, 1)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-btn-primary {
          background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
          border: none;
          font-weight: 600;
        }
        .ant-card {
          border: 1px solid #e2e8f0;
        }
      `
    }
  },
  {
    name: '金融科技',
    description: '金融科技风格，绿色主调配色体现财富与稳定',
    category: '商务',
    variables: {
      primaryColor: '#059669',
      secondaryColor: '#047857',
      accentColor: '#10b981',
      successColor: '#059669',
      warningColor: '#f59e0b',
      errorColor: '#ef4444',
      infoColor: '#3b82f6',
      backgroundColor: '#f0fdf4',
      surfaceColor: '#ffffff',
      cardColor: '#ffffff',
      borderColor: '#bbf7d0',
      textColor: '#064e3b',
      textSecondaryColor: '#047857',
      textDisabledColor: '#a7f3d0',
      hoverColor: '#ecfdf5',
      activeColor: '#d1fae5',
      backgroundOpacity: 1,
      cardOpacity: 1,
      borderOpacity: 1,
      borderRadius: '10px',
      cardBorderRadius: '16px',
      buttonBorderRadius: '10px',
      boxShadow: '0 4px 6px rgba(5, 150, 105, 0.1)',
      cardShadow: '0 10px 15px rgba(5, 150, 105, 0.1)',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '1.6',
      spacing: '18px',
      padding: '18px',
      margin: '18px',
      transitionDuration: '0.3s',
      transitionTiming: 'cubic-bezier(0.4, 0, 0.2, 1)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-btn-primary {
          background: linear-gradient(135deg, #059669 0%, #10b981 100%);
          border: none;
          box-shadow: 0 4px 14px rgba(5, 150, 105, 0.3);
        }
        .ant-card {
          border: 1px solid #bbf7d0;
          background: linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%);
        }
      `
    }
  },
  // 深色主题
  {
    name: '深色科技',
    description: '深色主题，适合夜间使用，科技感十足',
    category: '深色',
    variables: {
      primaryColor: '#177ddc',
      secondaryColor: '#722ed1',
      accentColor: '#13c2c2',
      successColor: '#52c41a',
      warningColor: '#faad14',
      errorColor: '#ff4d4f',
      infoColor: '#177ddc',
      backgroundColor: '#141414',
      surfaceColor: '#1f1f1f',
      cardColor: '#262626',
      borderColor: '#434343',
      textColor: '#ffffff',
      textSecondaryColor: '#a6a6a6',
      textDisabledColor: '#595959',
      hoverColor: '#2a2a2a',
      activeColor: '#111b26',
      backgroundOpacity: 1,
      cardOpacity: 0.9,
      borderOpacity: 0.8,
      borderRadius: '8px',
      cardBorderRadius: '12px',
      buttonBorderRadius: '8px',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3)',
      cardShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '1.5',
      spacing: '16px',
      padding: '16px',
      margin: '16px',
      transitionDuration: '0.3s',
      transitionTiming: 'cubic-bezier(0.4, 0, 0.2, 1)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-layout {
          background: linear-gradient(135deg, #141414 0%, #1a1a1a 100%);
        }
        .ant-card {
          background: rgba(38, 38, 38, 0.8);
          backdrop-filter: blur(10px);
        }
      `
    }
  },
  {
    name: '午夜黑',
    description: '纯黑主题，极简深色设计，护眼舒适',
    category: '深色',
    variables: {
      primaryColor: '#ffffff',
      secondaryColor: '#a0a0a0',
      accentColor: '#00d4ff',
      successColor: '#00ff88',
      warningColor: '#ffaa00',
      errorColor: '#ff4444',
      infoColor: '#4488ff',
      backgroundColor: '#000000',
      surfaceColor: '#111111',
      cardColor: '#1a1a1a',
      borderColor: '#333333',
      textColor: '#ffffff',
      textSecondaryColor: '#888888',
      textDisabledColor: '#444444',
      hoverColor: '#222222',
      activeColor: '#333333',
      backgroundOpacity: 1,
      cardOpacity: 0.95,
      borderOpacity: 0.7,
      borderRadius: '12px',
      cardBorderRadius: '16px',
      buttonBorderRadius: '12px',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
      cardShadow: '0 16px 48px rgba(0, 0, 0, 0.6)',
      fontFamily: 'SF Pro Display, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: '15px',
      fontWeight: '400',
      lineHeight: '1.6',
      spacing: '24px',
      padding: '24px',
      margin: '24px',
      transitionDuration: '0.4s',
      transitionTiming: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-layout {
          background: #000000;
        }
        .ant-card {
          background: rgba(26, 26, 26, 0.9);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }
        .ant-btn-primary {
          background: linear-gradient(135deg, #00d4ff 0%, #4488ff 100%);
          border: none;
          color: #000000;
          font-weight: 600;
        }
        .ant-btn-primary:hover {
          background: linear-gradient(135deg, #00b8e6 0%, #3366cc 100%);
          transform: translateY(-2px);
        }
      `
    }
  },
  {
    name: '深空紫',
    description: '深紫色调，神秘而优雅的深色主题',
    category: '深色',
    variables: {
      primaryColor: '#8b5cf6',
      secondaryColor: '#a855f7',
      accentColor: '#c084fc',
      successColor: '#10b981',
      warningColor: '#f59e0b',
      errorColor: '#ef4444',
      infoColor: '#3b82f6',
      backgroundColor: '#0f0f23',
      surfaceColor: '#1a1a2e',
      cardColor: '#16213e',
      borderColor: '#4c1d95',
      textColor: '#e2e8f0',
      textSecondaryColor: '#94a3b8',
      textDisabledColor: '#475569',
      hoverColor: '#1e293b',
      activeColor: '#312e81',
      backgroundOpacity: 1,
      cardOpacity: 0.9,
      borderOpacity: 0.8,
      borderRadius: '16px',
      cardBorderRadius: '20px',
      buttonBorderRadius: '16px',
      boxShadow: '0 10px 25px rgba(139, 92, 246, 0.2)',
      cardShadow: '0 20px 40px rgba(139, 92, 246, 0.3)',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '1.6',
      spacing: '20px',
      padding: '20px',
      margin: '20px',
      transitionDuration: '0.3s',
      transitionTiming: 'cubic-bezier(0.4, 0, 0.2, 1)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-layout {
          background: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%);
        }
        .ant-card {
          background: rgba(22, 33, 62, 0.8);
          backdrop-filter: blur(15px);
          border: 1px solid rgba(139, 92, 246, 0.3);
        }
        .ant-btn-primary {
          background: linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%);
          border: none;
          box-shadow: 0 4px 15px rgba(139, 92, 246, 0.4);
        }
        .ant-btn-primary:hover {
          background: linear-gradient(135deg, #7c3aed 0%, #9333ea 100%);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(139, 92, 246, 0.6);
        }
      `
    }
  },
  // 渐变主题
  {
    name: '渐变梦幻',
    description: '美丽的渐变色彩，梦幻般的视觉效果',
    category: '渐变',
    variables: {
      primaryColor: '#667eea',
      secondaryColor: '#764ba2',
      accentColor: '#f093fb',
      successColor: '#4facfe',
      warningColor: '#f093fb',
      errorColor: '#ff6b6b',
      infoColor: '#4facfe',
      backgroundColor: '#f0f2f5',
      surfaceColor: '#ffffff',
      cardColor: '#ffffff',
      borderColor: 'rgba(102, 126, 234, 0.2)',
      textColor: '#2c3e50',
      textSecondaryColor: '#7f8c8d',
      textDisabledColor: '#bdc3c7',
      hoverColor: 'rgba(102, 126, 234, 0.1)',
      activeColor: 'rgba(102, 126, 234, 0.2)',
      backgroundOpacity: 1,
      cardOpacity: 0.95,
      borderOpacity: 0.6,
      borderRadius: '12px',
      cardBorderRadius: '16px',
      buttonBorderRadius: '12px',
      boxShadow: '0 8px 32px rgba(102, 126, 234, 0.15)',
      cardShadow: '0 16px 48px rgba(102, 126, 234, 0.2)',
      gradientPrimary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      gradientSecondary: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      gradientBackground: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      gradientDirection: '135deg',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '1.6',
      spacing: '20px',
      padding: '20px',
      margin: '20px',
      transitionDuration: '0.4s',
      transitionTiming: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-layout {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          min-height: 100vh;
        }
        .ant-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.3);
        }
        .ant-btn-primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
        }
        .ant-btn-primary:hover {
          background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
        }
      `
    }
  },
  {
    name: '彩虹渐变',
    description: '多彩渐变主题，活力四射的视觉效果',
    category: '渐变',
    variables: {
      primaryColor: '#ff6b6b',
      secondaryColor: '#4ecdc4',
      accentColor: '#45b7d1',
      successColor: '#96ceb4',
      warningColor: '#feca57',
      errorColor: '#ff9ff3',
      infoColor: '#54a0ff',
      backgroundColor: '#f8f9fa',
      surfaceColor: '#ffffff',
      cardColor: '#ffffff',
      borderColor: 'rgba(255, 107, 107, 0.2)',
      textColor: '#2c3e50',
      textSecondaryColor: '#7f8c8d',
      textDisabledColor: '#bdc3c7',
      hoverColor: 'rgba(255, 107, 107, 0.1)',
      activeColor: 'rgba(255, 107, 107, 0.2)',
      backgroundOpacity: 1,
      cardOpacity: 0.95,
      borderOpacity: 0.6,
      borderRadius: '20px',
      cardBorderRadius: '24px',
      buttonBorderRadius: '20px',
      boxShadow: '0 10px 30px rgba(255, 107, 107, 0.2)',
      cardShadow: '0 20px 40px rgba(255, 107, 107, 0.25)',
      gradientPrimary: 'linear-gradient(45deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4)',
      gradientSecondary: 'linear-gradient(45deg, #feca57, #ff9ff3, #54a0ff, #5f27cd)',
      gradientBackground: 'linear-gradient(135deg, #ff6b6b 0%, #4ecdc4 25%, #45b7d1 50%, #96ceb4 75%, #feca57 100%)',
      gradientDirection: '135deg',
      fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: '15px',
      fontWeight: '500',
      lineHeight: '1.7',
      spacing: '24px',
      padding: '24px',
      margin: '24px',
      transitionDuration: '0.5s',
      transitionTiming: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-layout {
          background: linear-gradient(135deg, #ff6b6b 0%, #4ecdc4 25%, #45b7d1 50%, #96ceb4 75%, #feca57 100%);
          background-size: 400% 400%;
          animation: gradientShift 8s ease infinite;
          min-height: 100vh;
        }
        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .ant-card {
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(25px);
          border: 1px solid rgba(255, 255, 255, 0.4);
        }
        .ant-btn-primary {
          background: linear-gradient(45deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4);
          background-size: 300% 300%;
          animation: gradientMove 3s ease infinite;
          border: none;
          color: white;
          font-weight: 600;
        }
        @keyframes gradientMove {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .ant-btn-primary:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(255, 107, 107, 0.4);
        }
      `
    }
  },
  {
    name: '日落橙',
    description: '温暖日落色调，橙红渐变营造温馨氛围',
    category: '渐变',
    variables: {
      primaryColor: '#ff7e5f',
      secondaryColor: '#feb47b',
      accentColor: '#ff6b6b',
      successColor: '#4ecdc4',
      warningColor: '#feca57',
      errorColor: '#ff4757',
      infoColor: '#3742fa',
      backgroundColor: '#fff5f5',
      surfaceColor: '#ffffff',
      cardColor: '#ffffff',
      borderColor: 'rgba(255, 126, 95, 0.3)',
      textColor: '#2c2c54',
      textSecondaryColor: '#8b7d6b',
      textDisabledColor: '#c7c7c7',
      hoverColor: 'rgba(255, 126, 95, 0.1)',
      activeColor: 'rgba(255, 126, 95, 0.2)',
      backgroundOpacity: 1,
      cardOpacity: 0.95,
      borderOpacity: 0.7,
      borderRadius: '16px',
      cardBorderRadius: '20px',
      buttonBorderRadius: '16px',
      boxShadow: '0 8px 25px rgba(255, 126, 95, 0.2)',
      cardShadow: '0 15px 35px rgba(255, 126, 95, 0.25)',
      gradientPrimary: 'linear-gradient(135deg, #ff7e5f 0%, #feb47b 100%)',
      gradientSecondary: 'linear-gradient(135deg, #ff6b6b 0%, #feca57 100%)',
      gradientBackground: 'linear-gradient(135deg, #ff7e5f 0%, #feb47b 50%, #ff6b6b 100%)',
      gradientDirection: '135deg',
      fontFamily: 'Nunito, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '1.6',
      spacing: '20px',
      padding: '20px',
      margin: '20px',
      transitionDuration: '0.4s',
      transitionTiming: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-layout {
          background: linear-gradient(135deg, #ff7e5f 0%, #feb47b 50%, #ff6b6b 100%);
          min-height: 100vh;
        }
        .ant-card {
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 126, 95, 0.3);
        }
        .ant-btn-primary {
          background: linear-gradient(135deg, #ff7e5f 0%, #feb47b 100%);
          border: none;
          box-shadow: 0 6px 20px rgba(255, 126, 95, 0.4);
        }
        .ant-btn-primary:hover {
          background: linear-gradient(135deg, #ff6b47 0%, #fea85a 100%);
          transform: translateY(-2px);
          box-shadow: 0 10px 30px rgba(255, 126, 95, 0.6);
        }
      `
    }
  },
  {
    name: '海洋波浪',
    description: '蓝色海洋渐变，波浪般的流动感',
    category: '渐变',
    variables: {
      primaryColor: '#667eea',
      secondaryColor: '#764ba2',
      accentColor: '#f093fb',
      successColor: '#4facfe',
      warningColor: '#f093fb',
      errorColor: '#ff6b6b',
      infoColor: '#4facfe',
      backgroundColor: '#f0f2f5',
      surfaceColor: '#ffffff',
      cardColor: '#ffffff',
      borderColor: 'rgba(102, 126, 234, 0.2)',
      textColor: '#2c3e50',
      textSecondaryColor: '#7f8c8d',
      textDisabledColor: '#bdc3c7',
      hoverColor: 'rgba(102, 126, 234, 0.1)',
      activeColor: 'rgba(102, 126, 234, 0.2)',
      backgroundOpacity: 1,
      cardOpacity: 0.95,
      borderOpacity: 0.6,
      borderRadius: '12px',
      cardBorderRadius: '16px',
      buttonBorderRadius: '12px',
      boxShadow: '0 8px 32px rgba(102, 126, 234, 0.15)',
      cardShadow: '0 16px 48px rgba(102, 126, 234, 0.2)',
      gradientPrimary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      gradientSecondary: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      gradientBackground: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      gradientDirection: '135deg',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '1.6',
      spacing: '20px',
      padding: '20px',
      margin: '20px',
      transitionDuration: '0.4s',
      transitionTiming: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-layout {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          min-height: 100vh;
        }
        .ant-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.3);
        }
        .ant-btn-primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
        }
        .ant-btn-primary:hover {
          background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
        }
      `
    }
  },
  // 现代主题
  {
    name: '毛玻璃',
    description: '毛玻璃效果，现代感十足的半透明设计',
    category: '现代',
    variables: {
      primaryColor: '#1890ff',
      secondaryColor: '#722ed1',
      accentColor: '#13c2c2',
      successColor: '#52c41a',
      warningColor: '#faad14',
      errorColor: '#ff4d4f',
      infoColor: '#1890ff',
      backgroundColor: '#f0f2f5',
      surfaceColor: 'rgba(255, 255, 255, 0.1)',
      cardColor: 'rgba(255, 255, 255, 0.2)',
      borderColor: 'rgba(255, 255, 255, 0.3)',
      textColor: '#262626',
      textSecondaryColor: '#8c8c8c',
      textDisabledColor: '#bfbfbf',
      hoverColor: 'rgba(255, 255, 255, 0.2)',
      activeColor: 'rgba(24, 144, 255, 0.2)',
      backgroundOpacity: 1,
      cardOpacity: 0.8,
      borderOpacity: 0.6,
      borderRadius: '16px',
      cardBorderRadius: '20px',
      buttonBorderRadius: '16px',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
      cardShadow: '0 16px 48px rgba(0, 0, 0, 0.15)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '1.5',
      spacing: '16px',
      padding: '16px',
      margin: '16px',
      transitionDuration: '0.3s',
      transitionTiming: 'cubic-bezier(0.4, 0, 0.2, 1)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-layout {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          min-height: 100vh;
        }
        .ant-card {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
        .ant-btn {
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.3);
        }
        .ant-btn-primary {
          background: rgba(24, 144, 255, 0.8);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(24, 144, 255, 0.5);
        }
      `
    }
  },
  {
    name: '未来科技',
    description: '未来科技风格，蓝色主调配色，科技感十足',
    category: '现代',
    variables: {
      primaryColor: '#00d4ff',
      secondaryColor: '#0099cc',
      accentColor: '#00ff88',
      successColor: '#00ff88',
      warningColor: '#ffaa00',
      errorColor: '#ff4444',
      infoColor: '#00d4ff',
      backgroundColor: '#0a0a0a',
      surfaceColor: '#1a1a1a',
      cardColor: '#2a2a2a',
      borderColor: '#00d4ff',
      textColor: '#ffffff',
      textSecondaryColor: '#80ffff',
      textDisabledColor: '#404040',
      hoverColor: 'rgba(0, 212, 255, 0.1)',
      activeColor: 'rgba(0, 212, 255, 0.2)',
      backgroundOpacity: 1,
      cardOpacity: 0.9,
      borderOpacity: 0.8,
      borderRadius: '12px',
      cardBorderRadius: '16px',
      buttonBorderRadius: '12px',
      boxShadow: '0 0 20px rgba(0, 212, 255, 0.3)',
      cardShadow: '0 0 30px rgba(0, 212, 255, 0.4)',
      fontFamily: 'SF Mono, Consolas, "Courier New", monospace',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '1.6',
      spacing: '20px',
      padding: '20px',
      margin: '20px',
      transitionDuration: '0.3s',
      transitionTiming: 'ease-in-out',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-layout {
          background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
        }
        .ant-card {
          background: rgba(42, 42, 42, 0.8);
          backdrop-filter: blur(15px);
          border: 1px solid rgba(0, 212, 255, 0.3);
          box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
        }
        .ant-btn-primary {
          background: linear-gradient(135deg, #00d4ff 0%, #0099cc 100%);
          border: none;
          color: #000000;
          font-weight: 600;
          box-shadow: 0 0 15px rgba(0, 212, 255, 0.4);
        }
        .ant-btn-primary:hover {
          background: linear-gradient(135deg, #00b8e6 0%, #007a99 100%);
          transform: translateY(-2px);
          box-shadow: 0 0 25px rgba(0, 212, 255, 0.6);
        }
        .glow-effect {
          box-shadow: 0 0 10px currentColor;
        }
      `
    }
  },
  {
    name: '极简白',
    description: '极简白色主题，纯净简洁的设计风格',
    category: '现代',
    variables: {
      primaryColor: '#000000',
      secondaryColor: '#666666',
      accentColor: '#1890ff',
      successColor: '#52c41a',
      warningColor: '#faad14',
      errorColor: '#ff4d4f',
      infoColor: '#1890ff',
      backgroundColor: '#ffffff',
      surfaceColor: '#ffffff',
      cardColor: '#ffffff',
      borderColor: '#f0f0f0',
      textColor: '#000000',
      textSecondaryColor: '#666666',
      textDisabledColor: '#bfbfbf',
      hoverColor: '#fafafa',
      activeColor: '#f0f0f0',
      backgroundOpacity: 1,
      cardOpacity: 1,
      borderOpacity: 1,
      borderRadius: '0px',
      cardBorderRadius: '0px',
      buttonBorderRadius: '0px',
      boxShadow: 'none',
      cardShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSize: '16px',
      fontWeight: '300',
      lineHeight: '1.6',
      spacing: '32px',
      padding: '32px',
      margin: '32px',
      transitionDuration: '0.2s',
      transitionTiming: 'ease-in-out',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-card {
          border: 1px solid #f0f0f0;
          box-shadow: none;
        }
        .ant-btn {
          border: 1px solid #000000;
          background: transparent;
          color: #000000;
          font-weight: 400;
        }
        .ant-btn-primary {
          background: #000000;
          color: #ffffff;
          border: 1px solid #000000;
        }
        .ant-btn:hover {
          background: #fafafa;
          border-color: #000000;
        }
        .ant-btn-primary:hover {
          background: #333333;
          border-color: #333333;
        }
      `
    }
  },
  {
    name: '苹果风格',
    description: '苹果设计风格，圆润的边角和柔和的阴影',
    category: '现代',
    variables: {
      primaryColor: '#007aff',
      secondaryColor: '#5856d6',
      accentColor: '#ff3b30',
      successColor: '#34c759',
      warningColor: '#ff9500',
      errorColor: '#ff3b30',
      infoColor: '#007aff',
      backgroundColor: '#f2f2f7',
      surfaceColor: '#ffffff',
      cardColor: '#ffffff',
      borderColor: '#e5e5ea',
      textColor: '#000000',
      textSecondaryColor: '#8e8e93',
      textDisabledColor: '#c7c7cc',
      hoverColor: '#f2f2f7',
      activeColor: '#e5e5ea',
      backgroundOpacity: 1,
      cardOpacity: 1,
      borderOpacity: 1,
      borderRadius: '12px',
      cardBorderRadius: '16px',
      buttonBorderRadius: '12px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      cardShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontSize: '15px',
      fontWeight: '400',
      lineHeight: '1.47',
      spacing: '20px',
      padding: '20px',
      margin: '20px',
      transitionDuration: '0.3s',
      transitionTiming: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-btn-primary {
          background: #007aff;
          border: none;
          border-radius: 12px;
          font-weight: 600;
        }
        .ant-btn-primary:hover {
          background: #0056b3;
          transform: translateY(-1px);
        }
        .ant-card {
          border-radius: 16px;
          border: 1px solid #e5e5ea;
        }
        .ant-input {
          border-radius: 12px;
        }
        .ant-select-selector {
          border-radius: 12px;
        }
      `
    }
  },
  {
    name: '极简主义',
    description: '极简设计，注重留白和简洁的视觉效果',
    category: '极简',
    variables: {
      primaryColor: '#000000',
      secondaryColor: '#666666',
      accentColor: '#ff6b6b',
      successColor: '#51cf66',
      warningColor: '#ffd43b',
      errorColor: '#ff6b6b',
      infoColor: '#339af0',
      backgroundColor: '#ffffff',
      surfaceColor: '#ffffff',
      cardColor: '#ffffff',
      borderColor: '#e9ecef',
      textColor: '#212529',
      textSecondaryColor: '#6c757d',
      textDisabledColor: '#adb5bd',
      hoverColor: '#f8f9fa',
      activeColor: '#e9ecef',
      backgroundOpacity: 1,
      cardOpacity: 1,
      borderOpacity: 1,
      borderRadius: '0px',
      cardBorderRadius: '0px',
      buttonBorderRadius: '0px',
      boxShadow: 'none',
      cardShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '300',
      lineHeight: '1.6',
      spacing: '24px',
      padding: '24px',
      margin: '24px',
      transitionDuration: '0.2s',
      transitionTiming: 'ease-in-out',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-card {
          border: 1px solid #e9ecef;
          box-shadow: none;
        }
        .ant-btn {
          border: 1px solid #000000;
          background: transparent;
          color: #000000;
        }
        .ant-btn-primary {
          background: #000000;
          color: #ffffff;
          border: 1px solid #000000;
        }
        .ant-btn:hover {
          background: #f8f9fa;
          border-color: #000000;
        }
        .ant-btn-primary:hover {
          background: #333333;
          border-color: #333333;
        }
      `
    }
  },
  {
    name: '温暖舒适',
    description: '温暖的色调，营造舒适温馨的氛围',
    category: '温暖',
    variables: {
      primaryColor: '#ff8a65',
      secondaryColor: '#ffb74d',
      accentColor: '#ffcc02',
      successColor: '#81c784',
      warningColor: '#ffb74d',
      errorColor: '#e57373',
      infoColor: '#64b5f6',
      backgroundColor: '#fafafa',
      surfaceColor: '#ffffff',
      cardColor: '#ffffff',
      borderColor: '#e0e0e0',
      textColor: '#3e2723',
      textSecondaryColor: '#8d6e63',
      textDisabledColor: '#a1887f',
      hoverColor: '#fff3e0',
      activeColor: '#ffe0b2',
      backgroundOpacity: 1,
      cardOpacity: 1,
      borderOpacity: 1,
      borderRadius: '8px',
      cardBorderRadius: '12px',
      buttonBorderRadius: '8px',
      boxShadow: '0 2px 8px rgba(255, 138, 101, 0.15)',
      cardShadow: '0 4px 16px rgba(255, 138, 101, 0.2)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '1.5',
      spacing: '16px',
      padding: '16px',
      margin: '16px',
      transitionDuration: '0.3s',
      transitionTiming: 'cubic-bezier(0.4, 0, 0.2, 1)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-layout {
          background: linear-gradient(135deg, #fff8e1 0%, #f3e5f5 100%);
        }
        .ant-card {
          background: rgba(255, 255, 255, 0.9);
          border: 1px solid rgba(255, 138, 101, 0.2);
        }
        .ant-btn-primary {
          background: linear-gradient(135deg, #ff8a65 0%, #ffb74d 100%);
          border: none;
        }
        .ant-btn-primary:hover {
          background: linear-gradient(135deg, #ff7043 0%, #ffa726 100%);
        }
      `
    }
  },
  {
    name: '赛博朋克',
    description: '未来科技风格，霓虹色彩和金属质感',
    category: '科技',
    variables: {
      primaryColor: '#00ffff',
      secondaryColor: '#ff00ff',
      accentColor: '#ffff00',
      successColor: '#00ff00',
      warningColor: '#ff8000',
      errorColor: '#ff0040',
      infoColor: '#0080ff',
      backgroundColor: '#0a0a0a',
      surfaceColor: '#1a1a1a',
      cardColor: '#2a2a2a',
      borderColor: '#00ffff',
      textColor: '#00ffff',
      textSecondaryColor: '#80ffff',
      textDisabledColor: '#404040',
      hoverColor: 'rgba(0, 255, 255, 0.1)',
      activeColor: 'rgba(0, 255, 255, 0.2)',
      backgroundOpacity: 1,
      cardOpacity: 0.9,
      borderOpacity: 0.8,
      borderRadius: '8px',
      cardBorderRadius: '12px',
      buttonBorderRadius: '6px',
      boxShadow: '0 0 20px rgba(0, 255, 255, 0.3)',
      cardShadow: '0 0 30px rgba(0, 255, 255, 0.4)',
      fontFamily: 'Consolas, "Courier New", monospace',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '1.5',
      spacing: '16px',
      padding: '16px',
      margin: '16px',
      transitionDuration: '0.3s',
      transitionTiming: 'ease-in-out',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .cyber-glow {
          box-shadow: 0 0 10px currentColor;
        }
        .cyber-border {
          border: 1px solid #00ffff;
          box-shadow: inset 0 0 10px rgba(0, 255, 255, 0.2);
        }
      `
    }
  },
  {
    name: '自然森林',
    description: '绿色自然主题，清新环保的感觉',
    category: '自然',
    variables: {
      primaryColor: '#228b22',
      secondaryColor: '#32cd32',
      accentColor: '#90ee90',
      successColor: '#00ff7f',
      warningColor: '#ffd700',
      errorColor: '#dc143c',
      infoColor: '#20b2aa',
      backgroundColor: '#f0fff0',
      surfaceColor: '#f5fffa',
      cardColor: '#e6ffe6',
      borderColor: '#98fb98',
      textColor: '#006400',
      textSecondaryColor: '#228b22',
      textDisabledColor: '#90ee90',
      hoverColor: '#f0fff0',
      activeColor: '#e6ffe6',
      backgroundOpacity: 1,
      cardOpacity: 1,
      borderOpacity: 1,
      borderRadius: '12px',
      cardBorderRadius: '16px',
      buttonBorderRadius: '8px',
      boxShadow: '0 4px 12px rgba(34, 139, 34, 0.2)',
      cardShadow: '0 6px 16px rgba(34, 139, 34, 0.3)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '1.5',
      spacing: '16px',
      padding: '16px',
      margin: '16px',
      transitionDuration: '0.3s',
      transitionTiming: 'ease-in-out',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      // 头部和导航条
      headerBackgroundColor: '#ffffff',
      headerTextColor: '#262626',
      headerHeight: '64px',
      headerPadding: '0 24px',
      headerBoxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      headerBorderBottom: '1px solid #f0f0f0',
      headerOpacity: 1,
      navBackgroundColor: '#ffffff',
      navTextColor: '#262626',
      navHoverColor: '#f0f0f0',
      navActiveColor: '#e6f7ff',
      navHeight: '48px',
      navPadding: '0 16px',
      navBorderRadius: '6px',
      navBoxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      navOpacity: 1,
      logoSize: '32px',
      logoColor: '#1890ff',
      logoHoverColor: '#40a9ff',
      menuItemPadding: '8px 16px',
      menuItemBorderRadius: '6px',
      menuItemHoverBackground: '#f0f0f0',
      menuItemActiveBackground: '#e6f7ff',
      menuItemTextColor: '#262626',
      menuItemHoverTextColor: '#1890ff',
      menuItemActiveTextColor: '#1890ff',
      customCSS: ''
    }
  },
  {
    name: '海洋蓝调',
    description: '海洋主题，蓝色系渐变和波浪感',
    category: '海洋',
    variables: {
      primaryColor: '#0066cc',
      secondaryColor: '#0099ff',
      accentColor: '#66ccff',
      successColor: '#00cc99',
      warningColor: '#ffcc00',
      errorColor: '#ff6666',
      infoColor: '#0099cc',
      backgroundColor: '#e6f3ff',
      surfaceColor: '#f0f8ff',
      cardColor: '#cce7ff',
      borderColor: '#99d6ff',
      textColor: '#003366',
      textSecondaryColor: '#0066cc',
      textDisabledColor: '#99d6ff',
      hoverColor: '#e6f3ff',
      activeColor: '#cce7ff',
      backgroundOpacity: 1,
      cardOpacity: 1,
      borderOpacity: 1,
      borderRadius: '12px',
      cardBorderRadius: '16px',
      buttonBorderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 102, 204, 0.2)',
      cardShadow: '0 6px 16px rgba(0, 102, 204, 0.3)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '1.5',
      spacing: '16px',
      padding: '16px',
      margin: '16px',
      transitionDuration: '0.3s',
      transitionTiming: 'ease-in-out',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ocean-wave {
          background: linear-gradient(45deg, #0066cc, #0099ff, #66ccff, #0099ff);
          background-size: 400% 400%;
          animation: wave 3s ease-in-out infinite;
        }
        @keyframes wave {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
      `
    }
  },

  // ARK聊天整合主题
  {
    name: 'ARK聊天整合',
    description: '基于ark-chat-consolidation项目的现代化主题，支持跨服务器聊天和实时同步',
    category: 'ARK',
    variables: {
      primaryColor: '#667eea',
      secondaryColor: '#764ba2',
      accentColor: '#f093fb',
      successColor: '#4facfe',
      warningColor: '#f093fb',
      errorColor: '#ff6b6b',
      infoColor: '#4facfe',
      backgroundColor: '#f0f2f5',
      surfaceColor: 'rgba(255, 255, 255, 0.95)',
      cardColor: 'rgba(255, 255, 255, 0.9)',
      borderColor: 'rgba(102, 126, 234, 0.2)',
      textColor: '#2c3e50',
      textSecondaryColor: '#7f8c8d',
      textDisabledColor: '#bdc3c7',
      hoverColor: 'rgba(102, 126, 234, 0.1)',
      activeColor: 'rgba(102, 126, 234, 0.2)',
      backgroundOpacity: 1,
      cardOpacity: 0.95,
      borderOpacity: 0.6,
      borderRadius: '12px',
      cardBorderRadius: '16px',
      buttonBorderRadius: '12px',
      boxShadow: '0 8px 32px rgba(102, 126, 234, 0.15)',
      cardShadow: '0 16px 48px rgba(102, 126, 234, 0.2)',
      gradientPrimary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      gradientSecondary: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      gradientBackground: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '1.6',
      spacing: '20px',
      padding: '20px',
      margin: '20px',
      transitionDuration: '0.4s',
      transitionTiming: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      // 头部和导航条
      headerBackgroundColor: 'rgba(255, 255, 255, 0.95)',
      headerTextColor: '#2c3e50',
      headerHeight: '64px',
      headerPadding: '0 24px',
      headerBoxShadow: '0 2px 20px rgba(102, 126, 234, 0.1)',
      headerBorderBottom: '1px solid rgba(102, 126, 234, 0.1)',
      headerOpacity: 0.95,
      navBackgroundColor: 'rgba(255, 255, 255, 0.9)',
      navTextColor: '#2c3e50',
      navHoverColor: 'rgba(102, 126, 234, 0.1)',
      navActiveColor: 'rgba(102, 126, 234, 0.2)',
      navHeight: '48px',
      navPadding: '0 16px',
      navBorderRadius: '12px',
      navBoxShadow: '0 4px 16px rgba(102, 126, 234, 0.1)',
      navOpacity: 0.9,
      logoSize: '32px',
      logoColor: '#667eea',
      logoHoverColor: '#764ba2',
      menuItemPadding: '12px 20px',
      menuItemBorderRadius: '12px',
      menuItemHoverBackground: 'rgba(102, 126, 234, 0.1)',
      menuItemActiveBackground: 'rgba(102, 126, 234, 0.2)',
      menuItemTextColor: '#2c3e50',
      menuItemHoverTextColor: '#667eea',
      menuItemActiveTextColor: '#667eea',
      customCSS: `
        /* ARK聊天整合主题 - 现代化设计 */
        .ant-layout {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          min-height: 100vh;
          position: relative;
        }
        
        .ant-layout::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.05)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
          pointer-events: none;
        }
        
        .ant-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 16px;
          box-shadow: 0 16px 48px rgba(102, 126, 234, 0.2);
          transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        
        .ant-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 24px 64px rgba(102, 126, 234, 0.3);
        }
        
        .ant-btn {
          border-radius: 12px;
          font-weight: 500;
          transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          border: none;
          position: relative;
          overflow: hidden;
        }
        
        .ant-btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          transition: left 0.5s;
        }
        
        .ant-btn:hover::before {
          left: 100%;
        }
        
        .ant-btn-primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
        }
        
        .ant-btn-primary:hover {
          background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
        }
        
        .ant-input, .ant-select-selector, .ant-input-number {
          border-radius: 12px;
          border: 1px solid rgba(102, 126, 234, 0.2);
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }
        
        .ant-input:focus, .ant-select-focused .ant-select-selector, .ant-input-number:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
        }
        
        .ant-table {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 16px;
          overflow: hidden;
        }
        
        .ant-table-thead > tr > th {
          background: rgba(102, 126, 234, 0.1);
          border-bottom: 1px solid rgba(102, 126, 234, 0.2);
          color: #2c3e50;
          font-weight: 600;
        }
        
        .ant-table-tbody > tr > td {
          border-bottom: 1px solid rgba(102, 126, 234, 0.1);
        }
        
        .ant-table-tbody > tr:hover > td {
          background: rgba(102, 126, 234, 0.05);
        }
        
        .ant-modal-content {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 20px;
        }
        
        .ant-menu {
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(20px);
          border-radius: 12px;
          border: 1px solid rgba(255, 255, 255, 0.3);
        }
        
        .ant-menu-item {
          border-radius: 8px;
          margin: 4px 8px;
          transition: all 0.3s ease;
        }
        
        .ant-menu-item:hover {
          background: rgba(102, 126, 234, 0.1);
        }
        
        .ant-menu-item-selected {
          background: rgba(102, 126, 234, 0.2);
          color: #667eea;
        }
        
        .ant-tabs {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 16px;
          padding: 20px;
          border: 1px solid rgba(255, 255, 255, 0.3);
        }
        
        .ant-tabs-tab {
          border-radius: 8px;
          transition: all 0.3s ease;
        }
        
        .ant-tabs-tab:hover {
          background: rgba(102, 126, 234, 0.1);
        }
        
        .ant-tabs-tab-active {
          background: rgba(102, 126, 234, 0.2);
        }
        
        .ant-tabs-tab-active .ant-tabs-tab-btn {
          color: #667eea;
          font-weight: 600;
        }
        
        .ant-tabs-ink-bar {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          height: 3px;
          border-radius: 2px;
        }
        
        /* 响应式设计 */
        @media (max-width: 768px) {
          .ant-card {
            margin: 10px;
            border-radius: 12px;
          }
          
          .ant-btn {
            border-radius: 8px;
          }
          
          .ant-input, .ant-select-selector {
            border-radius: 8px;
          }
        }
        
        /* 聊天消息样式 */
        .chat-message {
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          border-radius: 12px;
          padding: 12px 16px;
          margin: 8px 0;
          border: 1px solid rgba(102, 126, 234, 0.1);
          transition: all 0.3s ease;
        }
        
        .chat-message:hover {
          background: rgba(255, 255, 255, 0.95);
          transform: translateX(4px);
        }
        
        .chat-message.own {
          background: rgba(102, 126, 234, 0.1);
          border-color: rgba(102, 126, 234, 0.3);
        }
        
        /* 玩家列表样式 */
        .player-item {
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          border-radius: 12px;
          padding: 12px 16px;
          margin: 8px 0;
          border: 1px solid rgba(102, 126, 234, 0.1);
          transition: all 0.3s ease;
        }
        
        .player-item:hover {
          background: rgba(255, 255, 255, 0.95);
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);
        }
        
        .player-item.online {
          border-left: 4px solid #4facfe;
        }
        
        .player-item.offline {
          opacity: 0.7;
          border-left: 4px solid #bdc3c7;
        }
        
        /* 状态指示器 */
        .status-indicator {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 8px;
        }
        
        .status-indicator.online {
          background: #4facfe;
          box-shadow: 0 0 8px rgba(79, 172, 254, 0.5);
        }
        
        .status-indicator.offline {
          background: #bdc3c7;
        }
        
        /* 滚动条样式 */
        ::-webkit-scrollbar {
          width: 8px;
        }
        
        ::-webkit-scrollbar-track {
          background: rgba(102, 126, 234, 0.1);
          border-radius: 4px;
        }
        
        ::-webkit-scrollbar-thumb {
          background: rgba(102, 126, 234, 0.3);
          border-radius: 4px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
          background: rgba(102, 126, 234, 0.5);
        }
        
        /* 毛玻璃效果增强 */
        .glass-effect {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
        
        /* 渐变文字效果 */
        .gradient-text {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      `
    }
  },
  {
    name: 'ARK简洁版',
    description: 'ARK聊天整合主题的简洁版本，专注于核心的现代化设计',
    category: 'ARK',
    variables: {
      primaryColor: '#667eea',
      secondaryColor: '#764ba2',
      accentColor: '#f093fb',
      successColor: '#4facfe',
      warningColor: '#f093fb',
      errorColor: '#ff6b6b',
      infoColor: '#4facfe',
      backgroundColor: '#f0f2f5',
      surfaceColor: 'rgba(255, 255, 255, 0.95)',
      cardColor: 'rgba(255, 255, 255, 0.9)',
      borderColor: 'rgba(102, 126, 234, 0.2)',
      textColor: '#2c3e50',
      textSecondaryColor: '#7f8c8d',
      textDisabledColor: '#bdc3c7',
      hoverColor: 'rgba(102, 126, 234, 0.1)',
      activeColor: 'rgba(102, 126, 234, 0.2)',
      backgroundOpacity: 1,
      cardOpacity: 0.95,
      borderOpacity: 0.6,
      borderRadius: '12px',
      cardBorderRadius: '16px',
      buttonBorderRadius: '12px',
      boxShadow: '0 8px 32px rgba(102, 126, 234, 0.15)',
      cardShadow: '0 16px 48px rgba(102, 126, 234, 0.2)',
      gradientPrimary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      gradientSecondary: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      gradientBackground: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '1.6',
      spacing: '20px',
      padding: '20px',
      margin: '20px',
      transitionDuration: '0.4s',
      transitionTiming: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        /* ARK简洁版主题 */
        .ant-layout {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          min-height: 100vh;
        }
        
        .ant-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 16px;
          box-shadow: 0 16px 48px rgba(102, 126, 234, 0.2);
          transition: all 0.4s ease;
        }
        
        .ant-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 24px 64px rgba(102, 126, 234, 0.3);
        }
        
        .ant-btn-primary {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          border-radius: 12px;
          color: white;
          font-weight: 500;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
          transition: all 0.3s ease;
        }
        
        .ant-btn-primary:hover {
          background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
        }
        
        .ant-input, .ant-select-selector {
          border-radius: 12px;
          border: 1px solid rgba(102, 126, 234, 0.2);
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }
        
        .ant-input:focus, .ant-select-focused .ant-select-selector {
          border-color: #667eea;
          box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
        }
        
        .ant-table {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 16px;
          overflow: hidden;
        }
        
        .ant-table-thead > tr > th {
          background: rgba(102, 126, 234, 0.1);
          border-bottom: 1px solid rgba(102, 126, 234, 0.2);
          color: #2c3e50;
          font-weight: 600;
        }
        
        .ant-table-tbody > tr:hover > td {
          background: rgba(102, 126, 234, 0.05);
        }
        
        .ant-modal-content {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 20px;
        }
        
        .ant-menu {
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(20px);
          border-radius: 12px;
          border: 1px solid rgba(255, 255, 255, 0.3);
        }
        
        .ant-menu-item:hover {
          background: rgba(102, 126, 234, 0.1);
        }
        
        .ant-menu-item-selected {
          background: rgba(102, 126, 234, 0.2);
          color: #667eea;
        }
        
        .ant-tabs {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 16px;
          padding: 20px;
          border: 1px solid rgba(255, 255, 255, 0.3);
        }
        
        .ant-tabs-tab:hover {
          background: rgba(102, 126, 234, 0.1);
        }
        
        .ant-tabs-tab-active {
          background: rgba(102, 126, 234, 0.2);
        }
        
        .ant-tabs-tab-active .ant-tabs-tab-btn {
          color: #667eea;
          font-weight: 600;
        }
        
        .ant-tabs-ink-bar {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          height: 3px;
          border-radius: 2px;
        }
        
        /* 响应式设计 */
        @media (max-width: 768px) {
          .ant-card {
            margin: 10px;
            border-radius: 12px;
          }
          
          .ant-btn-primary {
            border-radius: 8px;
          }
          
          .ant-input, .ant-select-selector {
            border-radius: 8px;
          }
        }
        
        /* 滚动条样式 */
        ::-webkit-scrollbar {
          width: 8px;
        }
        
        ::-webkit-scrollbar-track {
          background: rgba(102, 126, 234, 0.1);
          border-radius: 4px;
        }
        
        ::-webkit-scrollbar-thumb {
          background: rgba(102, 126, 234, 0.3);
          border-radius: 4px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
          background: rgba(102, 126, 234, 0.5);
        }
      `
    }
  },

  // 游戏主题
  {
    name: '游戏竞技',
    description: '游戏竞技风格，红黑配色，充满战斗感',
    category: '游戏',
    variables: {
      primaryColor: '#ff0000',
      secondaryColor: '#cc0000',
      accentColor: '#ff6600',
      successColor: '#00ff00',
      warningColor: '#ffff00',
      errorColor: '#ff0000',
      infoColor: '#00ffff',
      backgroundColor: '#000000',
      surfaceColor: '#1a1a1a',
      cardColor: '#2a2a2a',
      borderColor: '#ff0000',
      textColor: '#ffffff',
      textSecondaryColor: '#cccccc',
      textDisabledColor: '#666666',
      hoverColor: 'rgba(255, 0, 0, 0.1)',
      activeColor: 'rgba(255, 0, 0, 0.2)',
      backgroundOpacity: 1,
      cardOpacity: 0.9,
      borderOpacity: 0.8,
      borderRadius: '8px',
      cardBorderRadius: '12px',
      buttonBorderRadius: '8px',
      boxShadow: '0 0 20px rgba(255, 0, 0, 0.3)',
      cardShadow: '0 0 30px rgba(255, 0, 0, 0.4)',
      fontFamily: 'Orbitron, "Courier New", monospace',
      fontSize: '14px',
      fontWeight: '600',
      lineHeight: '1.5',
      spacing: '16px',
      padding: '16px',
      margin: '16px',
      transitionDuration: '0.3s',
      transitionTiming: 'ease-in-out',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-layout {
          background: linear-gradient(135deg, #000000 0%, #1a1a1a 100%);
        }
        .ant-card {
          background: rgba(42, 42, 42, 0.8);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 0, 0, 0.3);
          box-shadow: 0 0 20px rgba(255, 0, 0, 0.2);
        }
        .ant-btn-primary {
          background: linear-gradient(135deg, #ff0000 0%, #cc0000 100%);
          border: none;
          color: #ffffff;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
          box-shadow: 0 0 15px rgba(255, 0, 0, 0.4);
        }
        .ant-btn-primary:hover {
          background: linear-gradient(135deg, #ff3333 0%, #ff0000 100%);
          transform: translateY(-2px);
          box-shadow: 0 0 25px rgba(255, 0, 0, 0.6);
        }
        .game-glow {
          box-shadow: 0 0 10px currentColor;
        }
      `
    }
  },
  {
    name: '像素复古',
    description: '像素复古风格，8位游戏怀旧感',
    category: '游戏',
    variables: {
      primaryColor: '#00ff00',
      secondaryColor: '#ff00ff',
      accentColor: '#ffff00',
      successColor: '#00ff00',
      warningColor: '#ffaa00',
      errorColor: '#ff0000',
      infoColor: '#00ffff',
      backgroundColor: '#000080',
      surfaceColor: '#0000aa',
      cardColor: '#0000cc',
      borderColor: '#00ff00',
      textColor: '#ffffff',
      textSecondaryColor: '#00ff00',
      textDisabledColor: '#666666',
      hoverColor: 'rgba(0, 255, 0, 0.1)',
      activeColor: 'rgba(0, 255, 0, 0.2)',
      backgroundOpacity: 1,
      cardOpacity: 0.9,
      borderOpacity: 0.8,
      borderRadius: '0px',
      cardBorderRadius: '0px',
      buttonBorderRadius: '0px',
      boxShadow: 'none',
      cardShadow: '0 0 10px rgba(0, 255, 0, 0.3)',
      fontFamily: 'Press Start 2P, "Courier New", monospace',
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '1.5',
      spacing: '16px',
      padding: '16px',
      margin: '16px',
      transitionDuration: '0.1s',
      transitionTiming: 'ease-in-out',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-layout {
          background: #000080;
          image-rendering: pixelated;
        }
        .ant-card {
          background: #0000cc;
          border: 2px solid #00ff00;
          image-rendering: pixelated;
        }
        .ant-btn {
          background: #0000aa;
          border: 2px solid #00ff00;
          color: #00ff00;
          font-family: 'Press Start 2P', monospace;
          font-size: 10px;
          padding: 8px 16px;
        }
        .ant-btn-primary {
          background: #00ff00;
          color: #000080;
          border: 2px solid #00ff00;
        }
        .ant-btn:hover {
          background: #00cc00;
          border-color: #00cc00;
        }
        .pixel-border {
          border: 2px solid #00ff00;
        }
      `
    }
  },

  // 节日主题
  {
    name: '圣诞节日',
    description: '圣诞节主题，红绿配色，温馨节日氛围',
    category: '节日',
    variables: {
      primaryColor: '#dc143c',
      secondaryColor: '#228b22',
      accentColor: '#ffd700',
      successColor: '#228b22',
      warningColor: '#ffd700',
      errorColor: '#dc143c',
      infoColor: '#4169e1',
      backgroundColor: '#f0f8ff',
      surfaceColor: '#ffffff',
      cardColor: '#ffffff',
      borderColor: '#dc143c',
      textColor: '#2f4f4f',
      textSecondaryColor: '#696969',
      textDisabledColor: '#a9a9a9',
      hoverColor: 'rgba(220, 20, 60, 0.1)',
      activeColor: 'rgba(34, 139, 34, 0.1)',
      backgroundOpacity: 1,
      cardOpacity: 1,
      borderOpacity: 1,
      borderRadius: '12px',
      cardBorderRadius: '16px',
      buttonBorderRadius: '12px',
      boxShadow: '0 4px 12px rgba(220, 20, 60, 0.2)',
      cardShadow: '0 8px 20px rgba(220, 20, 60, 0.25)',
      fontFamily: 'Georgia, "Times New Roman", serif',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '1.6',
      spacing: '20px',
      padding: '20px',
      margin: '20px',
      transitionDuration: '0.3s',
      transitionTiming: 'ease-in-out',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-layout {
          background: linear-gradient(135deg, #f0f8ff 0%, #e6f3ff 100%);
        }
        .ant-card {
          border: 2px solid #dc143c;
          background: linear-gradient(135deg, #ffffff 0%, #fff8f0 100%);
        }
        .ant-btn-primary {
          background: linear-gradient(135deg, #dc143c 0%, #b22222 100%);
          border: none;
          color: #ffffff;
          font-weight: 600;
        }
        .ant-btn-primary:hover {
          background: linear-gradient(135deg, #ff1744 0%, #dc143c 100%);
          transform: translateY(-2px);
        }
        .christmas-sparkle {
          position: relative;
        }
        .christmas-sparkle::before {
          content: '✨';
          position: absolute;
          top: -5px;
          right: -5px;
          font-size: 12px;
        }
      `
    }
  },
  {
    name: '万圣节',
    description: '万圣节主题，橙黑配色，神秘恐怖氛围',
    category: '节日',
    variables: {
      primaryColor: '#ff8c00',
      secondaryColor: '#ff4500',
      accentColor: '#ffd700',
      successColor: '#32cd32',
      warningColor: '#ffd700',
      errorColor: '#dc143c',
      infoColor: '#9370db',
      backgroundColor: '#2f2f2f',
      surfaceColor: '#1a1a1a',
      cardColor: '#2a2a2a',
      borderColor: '#ff8c00',
      textColor: '#ffffff',
      textSecondaryColor: '#ff8c00',
      textDisabledColor: '#666666',
      hoverColor: 'rgba(255, 140, 0, 0.1)',
      activeColor: 'rgba(255, 140, 0, 0.2)',
      backgroundOpacity: 1,
      cardOpacity: 0.9,
      borderOpacity: 0.8,
      borderRadius: '8px',
      cardBorderRadius: '12px',
      buttonBorderRadius: '8px',
      boxShadow: '0 0 20px rgba(255, 140, 0, 0.3)',
      cardShadow: '0 0 30px rgba(255, 140, 0, 0.4)',
      fontFamily: 'Creepster, "Courier New", monospace',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '1.5',
      spacing: '16px',
      padding: '16px',
      margin: '16px',
      transitionDuration: '0.3s',
      transitionTiming: 'ease-in-out',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      customCSS: `
        .ant-layout {
          background: linear-gradient(135deg, #2f2f2f 0%, #1a1a1a 100%);
        }
        .ant-card {
          background: rgba(42, 42, 42, 0.8);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 140, 0, 0.3);
          box-shadow: 0 0 20px rgba(255, 140, 0, 0.2);
        }
        .ant-btn-primary {
          background: linear-gradient(135deg, #ff8c00 0%, #ff4500 100%);
          border: none;
          color: #000000;
          font-weight: 700;
          text-transform: uppercase;
          box-shadow: 0 0 15px rgba(255, 140, 0, 0.4);
        }
        .ant-btn-primary:hover {
          background: linear-gradient(135deg, #ffa500 0%, #ff8c00 100%);
          transform: translateY(-2px);
          box-shadow: 0 0 25px rgba(255, 140, 0, 0.6);
        }
        .halloween-glow {
          box-shadow: 0 0 10px currentColor;
        }
      `
    }
  },
  // 测试背景图片主题
  {
    name: '背景图片测试',
    description: '用于测试背景图片功能的主题',
    category: '测试',
    variables: {
      primaryColor: '#1890ff',
      secondaryColor: '#722ed1',
      accentColor: '#13c2c2',
      successColor: '#52c41a',
      warningColor: '#faad14',
      errorColor: '#ff4d4f',
      infoColor: '#1890ff',
      backgroundColor: '#f5f5f5',
      surfaceColor: '#ffffff',
      cardColor: '#ffffff',
      borderColor: '#d9d9d9',
      textColor: '#262626',
      textSecondaryColor: '#8c8c8c',
      textDisabledColor: '#bfbfbf',
      hoverColor: '#f0f0f0',
      activeColor: '#e6f7ff',
      backgroundOpacity: 0.9,
      cardOpacity: 1,
      borderOpacity: 1,
      borderRadius: '6px',
      cardBorderRadius: '8px',
      buttonBorderRadius: '6px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
      cardShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '1.5',
      spacing: '16px',
      padding: '16px',
      margin: '16px',
      transitionDuration: '0.3s',
      transitionTiming: 'cubic-bezier(0.4, 0, 0.2, 1)',
      mobileBreakpoint: '768px',
      tabletBreakpoint: '1024px',
      // 背景图片设置
      backgroundImage: 'https://images.unsplash.com/photo-1557683316-973673baf926?w=1920&h=1080&fit=crop',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      // 头部和导航条
      headerBackgroundColor: '#ffffff',
      headerTextColor: '#262626',
      headerHeight: '64px',
      headerPadding: '0 24px',
      headerBoxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      headerBorderBottom: '1px solid #f0f0f0',
      headerOpacity: 1,
      navBackgroundColor: '#ffffff',
      navTextColor: '#262626',
      navHoverColor: '#f0f0f0',
      navActiveColor: '#e6f7ff',
      navHeight: '48px',
      navPadding: '0 16px',
      navBorderRadius: '6px',
      navBoxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      navOpacity: 1,
      logoSize: '32px',
      logoColor: '#1890ff',
      logoHoverColor: '#40a9ff',
      menuItemPadding: '8px 16px',
      menuItemBorderRadius: '6px',
      menuItemHoverBackground: '#f0f0f0',
      menuItemActiveBackground: '#e6f7ff',
      menuItemTextColor: '#262626',
      menuItemHoverTextColor: '#1890ff',
      menuItemActiveTextColor: '#1890ff',
      customCSS: ''
    }
  }
];

export const getPresetsByCategory = (category: string) => {
  return themePresets.filter(preset => preset.category === category);
};

export const getAllCategories = () => {
  const categories = themePresets.map(preset => preset.category);
  return Array.from(new Set(categories));
};
